import { observer } from "mobx-react-lite";
import React, { useEffect, useRef } from "react";
import { useContext } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import SearchForm from "../components/forms/SearchForm";
import SearchResults from "../components/widgets/SearchResults";
import { toast } from "react-toastify";

const SearchPage: React.FC<RouteComponentProps> = () => {
  const rootStore = useContext(RootStoreContext);
  const { resetSearch, attendingMeeting,IsStoredSearchResults } = rootStore.playerStore;
  const { setSourceId } = rootStore.meetingStore;
  const link = useRef<HTMLAnchorElement | null>(null);
  
  const handleActionDownload = (filename : string, href : string ) => {
    // console.log("Download file: ", filename, " from: ", href);
    link.current!.download = filename;
    link.current!.href = href;
    link.current!.click();
  }



  useEffect(() => {
   
    if (attendingMeeting) setSourceId(attendingMeeting?.id);
    else setSourceId(null);
     if(!IsStoredSearchResults){

      resetSearch();
     }
    return () => {
      // if(!storedSearchResults){
      // resetSearch();
      // }
    };
  }, [resetSearch, attendingMeeting, setSourceId]);

  return (
    <>
    <a role="button" href="/#" ref={link} style={{display: "none"}} > </a>
    <div>
      <Row className="searchForm" >
        <Col xs={12}>
          <SearchForm />
        </Col>
      </Row>
      <Row className="searchResult">
        <Col xs={12}>
          <SearchResults handleActionDownload={handleActionDownload} />
  
        </Col>
      </Row>
    </div>
    </>
  );
};

export default observer(SearchPage);
